import { REDUCER_NAME as PARENT_REDUCER_NAME } from '../const'
import { REDUCER_NAME } from './const'

const NS = PARENT_REDUCER_NAME + '/' + REDUCER_NAME + '/'

export const FIND_PROSPECT_REQUEST = NS + 'FIND_PROSPECT_REQUEST'
export const FIND_PROSPECT_SUCCESS = NS + 'FIND_PROSPECT_SUCCESS'
export const FIND_PROSPECT_ERROR = NS + 'FIND_PROSPECT_ERROR'

export const CHANGE_PROSPECT = NS + 'CHANGE_PROSPECT'

export const SAVE_PROSPECT_REQUEST = NS + 'SAVE_PROSPECT_REQUEST'
export const SAVE_PROSPECT_SUCCESS = NS + 'SAVE_PROSPECT_SUCCESS'
export const SAVE_PROSPECT_ERROR = NS + 'SAVE_PROSPECT_ERROR'

export const ARCHIVE_PROSPECT_REQUEST = NS + 'ARCHIVE_PROSPECT_REQUEST'
export const ARCHIVE_PROSPECT_SUCCESS = NS + 'ARCHIVE_PROSPECT_SUCCESS'
export const ARCHIVE_PROSPECT_ERROR = NS + 'ARCHIVE_PROSPECT_ERROR'

export const NO_SHOW_REQUEST = NS + 'NO_SHOW_REQUEST'
export const NO_SHOW_SUCCESS = NS + 'NO_SHOW_SUCCESS'
export const NO_SHOW_ERROR = NS + 'NO_SHOW_ERROR'

export const START_IN_SHOP_PROCESS_REQUEST = NS + 'START_IN_SHOP_PROCESS_REQUEST'
export const START_IN_SHOP_PROCESS_SUCCESS = NS + 'START_IN_SHOP_PROCESS_SUCCESS'
export const START_IN_SHOP_PROCESS_ERROR = NS + 'START_IN_SHOP_PROCESS_ERROR'



// WEBPACK FOOTER //
// ./src/modules/prospect/state/detail/type.js